/**
 * Motivational Quotes Library — 60+ professionally relevant quotes.
 *
 * Rotated daily on Wouter's dashboard. Displayed with author attribution.
 * Curated for a professional financial services context.
 */

const quotes = [
  { text: "Excellence is not a skill — it's an attitude.", author: "Ralph Marston" },
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "Small daily improvements over time lead to stunning results.", author: "Robin Sharma" },
  { text: "Success is the sum of small efforts repeated day in and day out.", author: "Robert Collier" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "Discipline is the bridge between goals and accomplishment.", author: "Jim Rohn" },
  { text: "Don't count the days, make the days count.", author: "Muhammad Ali" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "The professional has learned that success, like happiness, comes as a by-product of work.", author: "Steven Pressfield" },
  { text: "It's not about having time. It's about making time.", author: "Unknown" },
  { text: "Consistency is what transforms average into excellence.", author: "Unknown" },
  { text: "A smooth sea never made a skilled sailor.", author: "Franklin D. Roosevelt" },
  { text: "What you do today can improve all your tomorrows.", author: "Ralph Marston" },
  { text: "Professionalism is knowing how to do it, when to do it, and doing it.", author: "Frank Tyger" },
  { text: "The difference between ordinary and extraordinary is that little extra.", author: "Jimmy Johnson" },
  { text: "Work hard in silence. Let success make the noise.", author: "Frank Ocean" },
  { text: "Every accomplishment starts with the decision to try.", author: "John F. Kennedy" },
  { text: "Your work is going to fill a large part of your life. Make it great.", author: "Steve Jobs" },
  { text: "Do what you can, with what you have, where you are.", author: "Theodore Roosevelt" },
  { text: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb" },
  { text: "Focus on being productive instead of busy.", author: "Tim Ferriss" },
  { text: "You are never too old to set another goal or to dream a new dream.", author: "C.S. Lewis" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Well done is better than well said.", author: "Benjamin Franklin" },
  { text: "Opportunities don't happen. You create them.", author: "Chris Grosser" },
  { text: "Success usually comes to those who are too busy to be looking for it.", author: "Henry David Thoreau" },
  { text: "Don't wish it were easier. Wish you were better.", author: "Jim Rohn" },
  { text: "The harder you work for something, the greater you'll feel when you achieve it.", author: "Unknown" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Action is the foundational key to all success.", author: "Pablo Picasso" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "Setting goals is the first step in turning the invisible into the visible.", author: "Tony Robbins" },
  { text: "The only place where success comes before work is in the dictionary.", author: "Vidal Sassoon" },
  { text: "The best preparation for tomorrow is doing your best today.", author: "H. Jackson Brown Jr." },
  { text: "It always seems impossible until it's done.", author: "Nelson Mandela" },
  { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
  { text: "What we achieve inwardly will change outer reality.", author: "Plutarch" },
  { text: "Efficiency is doing things right. Effectiveness is doing the right things.", author: "Peter Drucker" },
  { text: "The client doesn't care how much you know until they know how much you care.", author: "Adapted from Teddy Roosevelt" },
  { text: "People don't buy products. They buy better versions of themselves.", author: "Samuel Hulick" },
  { text: "Trust is built with consistency.", author: "Lincoln Chafee" },
  { text: "The goal is not to be perfect by the end. The goal is to be better today.", author: "Simon Sinek" },
  { text: "Good service is good business.", author: "Siebel Ad" },
  { text: "If you are not willing to risk the usual, you will have to settle for the ordinary.", author: "Jim Rohn" },
  { text: "Motivation gets you going, but discipline keeps you growing.", author: "John C. Maxwell" },
  { text: "The biggest risk is not taking any risk.", author: "Mark Zuckerberg" },
  { text: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupéry" },
  { text: "Success is walking from failure to failure with no loss of enthusiasm.", author: "Winston Churchill" },
  { text: "Your most unhappy customers are your greatest source of learning.", author: "Bill Gates" },
  { text: "In the middle of difficulty lies opportunity.", author: "Albert Einstein" },
  { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
  { text: "To give real service you must add something which cannot be bought or measured with money.", author: "Douglas Adams" },
  { text: "Take care of your clients and the business will take care of itself.", author: "Ray Kroc" },
  { text: "Winning is a habit. Unfortunately, so is losing.", author: "Vince Lombardi" },
  { text: "We are what we repeatedly do. Excellence, then, is not an act, but a habit.", author: "Will Durant" },
  { text: "Progress is impossible without change, and those who cannot change their minds cannot change anything.", author: "George Bernard Shaw" },
  { text: "Clarity precedes mastery.", author: "Robin Sharma" },
  { text: "When you serve the client well, you serve yourself well.", author: "Unknown" },
  { text: "One client well taken care of could be worth more than ten thousand rand of advertising.", author: "Jim Rohn" },
  { text: "There are no shortcuts to any place worth going.", author: "Beverly Sills" },
  { text: "Chase the vision, not the money. The money will end up following you.", author: "Tony Hsieh" },
  { text: "Great things are done by a series of small things brought together.", author: "Vincent Van Gogh" },
];

/**
 * Get a random quote from the library.
 * In production, this could rotate daily using the date as a seed.
 */
export function getRandomQuote() {
  // Use the day of the year as a seed for consistent daily rotation
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((now - start) / (1000 * 60 * 60 * 24));
  const index = dayOfYear % quotes.length;
  return quotes[index];
}

/**
 * Get all quotes (for settings/admin display).
 */
export function getAllQuotes() {
  return quotes;
}

export default quotes;
